/* global window */

import React, { useContext, useEffect, useRef, useState } from 'react';
import IoMdCart from '../icons/IoMdCart';
import '../styles/Cart.css';
import { CartContext } from './context/CartContext';
import CartItem from './CartItem';
import { Link } from 'react-router-dom';
import getSymbolFromCurrency from 'currency-symbol-map';
import { bool, string } from 'prop-types';
import useCheckout from '../hooks/useCheckout';
import { Button } from 'react-bootstrap';
import AppContext from './context/AppContext';

export default function Cart({ isMobile }) {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const cartRef = useRef(null);
    const [showCart, setShowCart] = useState(false);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const {
        cartState,
        checkoutData,
        addLineItem,
        setLineItem,
        delLineItem,
        reloadLineItems,
        fetchCheckoutData,
    } = useContext(CartContext);
    const { setStartCheckout } = useCheckout();
    useEffect(() => {
        const detectOutsideClick = (e) => {
            if (cartRef.current
                && !cartRef.current.contains(e.target)) {
                setShowCart(false);
            }
        };
        window.addEventListener('click', detectOutsideClick, true);
        return () => {
            window.removeEventListener('click', detectOutsideClick, true);
        };
    }, []);
    useEffect(() => {
        setTotalItemCount(
            () => cartState.reduce(
                (accumulator, lineItem) => accumulator + lineItem.quantity,
                0,
            ),
        );
    }, [cartState]);
    return (<div
        ref={cartRef}
        className={'cart-container'}>
        <button
            onClick={() => setShowCart(!showCart)}
            aria-label={'Cart'}>
            <IoMdCart
                size={'35px'}
                color={'#4d4d4d'} />
            <span
                className={'cart-counter'}>
                {cartState
                    ?.map((item) => item.quantity)
                    .reduce((prev, cur) => +prev + +cur, 0)
                    ?? 0}
            </span>
        </button>
        {(showCart === true && cartState.length > 0) && (<div
            className={'cart-container--inner'}>
            {cartState.length > 0 && (cartState
                .map((lineItem) => (
                    <CartItem
                        key={lineItem.lineItemId}
                        lineItemId={lineItem.lineItemId}
                        isMobile={isMobile}
                        inventoryLevelId={lineItem.inventoryLevelId}
                        price={lineItem.price}
                        quantity={lineItem.quantity}
                        sku={lineItem.sku}
                        title={lineItem.title}
                        availableQuantity={lineItem.availableQuantity}
                        availableForSale={lineItem.availableForSale}
                        imageUrl={lineItem.imageUrl}
                        handle={lineItem.handle}
                        bypassNegativeQuantity={lineItem.bypassNegativeQuantity}
                    />
                )))}
            {cartState.length > 0 && (<>
                <div
                    className={'cart--actions'}>
                    <p
                        style={{
                            fontWeight: 'bold',
                            color: '#4d4d4d',
                            marginTop: '10px',
                            marginBottom: '0',
                        }}
                    >Subtotal: <span
                            style={{
                                color: 'var(--action-color)',
                            }}
                        >
                            {getSymbolFromCurrency(appConfig.storeCurrency)}{cartState
                                ?.map((item) => parseFloat(item.price))
                                .reduce((prev, cur) => +prev + +cur, 0)
                                .toFixed(2)
                                ?? 0} {appConfig.storeCurrency}
                        </span>
                    </p>
                    <div
                        className={'cart--actions-button-group'}>
                        <Link
                            className={'cart--checkout-btn'}
                            to={'/cart'}
                            onClick={() => setShowCart(false)}>View Cart</Link>
                        <Button
                            as={Link}
                            aria-label={'Checkout'}
                            className={'cart--checkout-btn'}
                            onClick={() => setStartCheckout(true)}>
                            Checkout{totalItemCount < 1
                                ? ''
                                : ` ${totalItemCount} item${
                                    totalItemCount > 1 ? 's' : ''
                                }`
                            }
                        </Button>
                    </div>
                </div>
            </>)}
        </div>)}
    </div>);
}

Cart.propTypes = {
    isMobile: bool,
    order: string,
};